module.exports = __webpack_public_path__ + "65946f8b639ab6ef6513581ed84d9ccc.pdf";